import "core-js/modules/es6.regexp.replace";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
function removeHttp(src) {
  if (!src) return src;
  if (_typeof(src) === 'object' && src.backgroundImage) {
    // src.backgroundImage = src.backgroundImage.replace('p.qpic.cn', 'puep.qpic.cn')
    src.backgroundImage = src.backgroundImage.replace(/^http:/, '');
    return src;
  }

  // src = src.replace('p.qpic.cn', 'puep.qpic.cn')

  return src.replace(/^http:/, '');
}
export default {
  filters: {
    removeHttp: removeHttp
  },
  methods: {
    removeHttp: removeHttp
  }
};